"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SpacerStyles = require("./Spacer-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Spacer(props) {
  return /*#__PURE__*/_react.default.createElement(_SpacerStyles.SpacerContainer, props);
}

var _default = Spacer;
exports.default = _default;